export const navLinks = [
  {
    label: 'Why Choose Us',
    path: '/',
    selector: 'why-choose-us-section',
  },
  {
    label: 'Services',
    path: '/',
    selector: 'services-section',
  },
  {
    label: 'The Team',
    path: '/members',
  },
  {
    label: 'Clients',
    path: '/',
    selector: 'testimonials',
  },
  {
    label: 'Vision to shipping',
    path: '/',
    selector: 'agile-process-section',
  },
  {
    label: 'Blog',
    href: 'https://blog.activetechconsult.com',
  },
];
